import React, { useState, useEffect, useRef } from "react";
import { API_BASE_URL } from "../config";
import { useNavigate, useLocation } from "react-router-dom"; // <-- import useLocation
import { useLoginModal } from "../contexts/LoginModalContext";
import "./Navbar.css";
import { CgProfile } from "react-icons/cg";
import { TfiWallet } from "react-icons/tfi";
import { Spinner } from "react-bootstrap";
const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation(); // <-- get current location
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isSession, setSession] = useState(null);
  const { setShowLoginModal } = useLoginModal();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [walletBalance, setWalletBalance] = useState();

  const dropdownRef = useRef(null);
  const handleLogout = () => {
    setShowLoginModal(false);
    sessionStorage.removeItem("user");
    setIsLoggedIn(false);
    setSession(null); // Clear session on logout
    window.location.href = "/";
  };

  // Back button handler
  const handleBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    const updateSession = () => {
      const user = JSON.parse(sessionStorage.getItem("user"));
      // console.log("User Id", user.payLoad.user.Id)
      if (user && user.payLoad.access_token) {
        setIsLoggedIn(true);
        setSession(user.payLoad.user);
      } else {
        setIsLoggedIn(false);
        setSession(null);
      }
    };

    updateSession();

    // Listen for package update event
    window.addEventListener("userPackageUpdated", updateSession);

    return () => {
      window.removeEventListener("userPackageUpdated", updateSession);
    };
  }, []);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  // Helper to check if path is active
  const isActive = (path) => {
    if (path === "/packages" && location.pathname.startsWith("/packages"))
      return true;
    if (
      path === "/appointment" &&
      (location.pathname.startsWith("/appointment") ||
        location.pathname.startsWith("/bookedappointment"))
    )
      return true;
    if (
      path === "/prescriptions" &&
      location.pathname.startsWith("/prescriptions")
    )
      return true;
    if (path === "/" && location.pathname === "/") return true;
    // Add more as needed
    return location.pathname === path;
  };

  const checkWalletBalance = async () => {
    const session = JSON.parse(sessionStorage.getItem("user"));
    const patientId = session?.payLoad?.user?.Id;

    if (!patientId) {
      console.warn("Patient ID is missing");
      return;
    }

    setIsLoading(true)
    try {
      const response = await fetch(`${API_BASE_URL}/wallet/balance?patientId=${patientId}`, {
        method: "GET",
      });

      if (!response.ok) {
        setIsLoading(false)
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Wallet balance response:", data);

      if (data.statusCode === 1) {
        const balance = data.payLoad?.balance;
        console.log("Wallet balance is:", balance);
        setIsLoading(false)
        setWalletBalance(balance)
        // set some state if needed
      } else {
        setIsLoading(false)
        console.warn("Failed to fetch balance:", data.statusMessage?.[0]);
      }
    } catch (error) {
      setIsLoading(false)
      console.error("Error fetching wallet balance:", error);
    }
  };

  useEffect(() => {
    checkWalletBalance();
  }, [])

  return (
    <>
      <nav
        className="navbar navbar-expand-lg px-5 py-3 bg-white"
        style={{ position: "sticky", top: 0, zIndex: 1030 }}
      >
        <div className="container-fluid ">
          <div className="d-flex align-items-center justify-content-between">
            <div className=" d-flex align-items-center">
              <img
                src="/logob.png"
                style={{
                  height: "18%",
                  width: "18%",
                  marginLeft: "20px",
                  cursor: "pointer", // <-- Add this line
                }}
                alt="Logo"
                className="navbar-logo"
                onClick={() =>
                  navigate("/")
                }
                // onClick={() =>
                //   (window.location.href = "https://webdocoffice.com.pk/")
                // }
              />
              {/* Back Button */}
              {/* <button
                className="btn btn-outline-light me-4"
                style={{
                  borderRadius: "50%",
                  width: "40px",
                  height: "40px",
                  marginLeft: "20px",
                }}
                onClick={handleBack}
                aria-label="Back"
              >
                &#8592;
              </button> */}
            </div>

            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNav"
              aria-controls="navbarNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
          </div>
          {/* Logo */}

          <div
            className="collapse navbar-collapse"
            style={{ width: "80%", color: "#00bcd4" }}
            id="navbarNav"
          >
            <ul className="navbar-nav ms-auto" style={{ columnGap: "10px" }}>
              <li className="nav-item">
                <a
                  className={`nav-link lp-header-btn ${isActive("/") ? " active" : ""
                    }`}
                  onClick={() => {
                    setShowLoginModal(false);
                    navigate("/");
                  }}
                >
                  Instant&nbsp;Doctors
                </a>
              </li>
              {isSession &&
                isSession.userPackages &&
                isSession.userPackages.packageName?.Id ? (
                <>
                  <li className="nav-item">
                    <a
                      className={`nav-link lp-header-btn ${isActive("/packages") ? " active" : ""
                        }`}
                      onClick={() => {
                        setShowLoginModal(false);
                        navigate("/packages");
                      }}
                    >
                      My&nbsp;Package
                    </a>
                  </li>
                </>
              ) : (
                <li className="nav-item">
                  <a
                    className={`nav-link lp-header-btn ${isActive("/packages") ? " active" : ""
                      }`}
                    onClick={() => {
                      setShowLoginModal(false);
                      navigate("/packages");
                    }}
                  >
                    Buy&nbsp;Package
                  </a>
                </li>
              )}

              {isLoggedIn ? (
                <>
                  <li className="nav-item">
                    <a
                      className={`nav-link lp-header-btn ${isActive("/appointment") ? " active" : ""
                        }`}
                      onClick={() => {
                        setShowLoginModal(false);
                        navigate("/appointment");
                      }}
                    >
                      Specialist&nbsp;Doctors
                    </a>
                  </li>

                  <li className="nav-item">
                    <a
                      className={`nav-link lp-header-btn ${isActive("/prescriptions") ? " active" : ""
                        }`}
                      onClick={() => {
                        setShowLoginModal(false);
                        navigate("/prescriptions");
                      }}
                    >
                      Prescriptions
                    </a>
                  </li>
                  <a
                    className="nav-link wallet_button"
                    onClick={() => navigate("/wallet")}
                  >
                    <TfiWallet size={25} /> <span className="ms-1 d-inline-flex">PKR/-&nbsp;{isLoading ? <Spinner size="sm" style={{color:"#FFFFFF"}} /> : walletBalance}</span>
                  </a>
                  <li className="nav-item position-relative" ref={dropdownRef}>
                    <a
                      className="nav-link lp-header-btn"
                      onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                      style={{ cursor: "pointer" }}
                    >
                      <CgProfile size={25} />
                    </a>

                    {isDropdownOpen && (
                      <div
                        className="dropdown-menu show"
                        style={{
                          position: "absolute",
                          top: "45px",
                          right: -10,
                          zIndex: 1050,
                          minWidth: "100px",
                          backgroundColor: "#fff",
                          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                          borderRadius: "6px",
                          padding: "6px 0",
                        }}
                      >
                        <a
                          className="dropdown-item lp-header-btn"
                          onClick={() => navigate("/profile")}
                        >
                          View&nbsp;Profile
                        </a>
                        {/* <a
                          className="dropdown-item lp-header-btn"
                          onClick={() => navigate("/wallet")}
                        >
                          Wallet
                        </a> */}

                        <a
                          className="lp-header-btn dropdown-item "
                          onClick={handleLogout}
                        >
                          Logout
                        </a>
                      </div>
                    )}
                  </li>
                </>
              ) : (
                <>
                  <li className="nav-item">
                    <a
                      className={`nav-link lp-header-btn ${isActive("/appointment") ? " active" : ""
                        }`}
                      onClick={() => {
                        setShowLoginModal(false);
                        navigate("/appointment");
                      }}
                    >
                      Specialist Doctors
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link lp-header-btn "
                      onClick={() => setShowLoginModal(true)}
                    >
                      Sign up / Login
                    </a>
                  </li>
                  {/* <li className="nav-item">
                    <a
                      className="nav-link lp-header-btn "
                      onClick={() => {
                        if (location.pathname.startsWith("/appointment")) {
                          navigate("/login/appointment");
                        } else {
                          setShowLoginModal(true);
                        }
                      }}
                    >
                      Sign up / Login
                    </a>
                  </li> */}
                </>
              )}
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
